class AjaxPaginationElement extends HTMLElement {
    connectedCallback() {
        this._onClick = this._handleClick.bind(this)
        this.addEventListener("click", this._onClick)
    }

    disconnectedCallback() {
        this.removeEventListener("click", this._onClick)
    }

    _handleClick(event) {
        const link = event.target.closest(".Pagination a[href]")
        if (!link || !this.contains(link)) return

        event.preventDefault()

        const href = link.getAttribute("href")
        const collectionSection = this.closest('[data-section-type="collection"]')

        if (collectionSection) {
            collectionSection.dispatchEvent(
                new CustomEvent("collection:pagination", {
                    bubbles: false,
                    detail: { url: href },
                })
            )
            return
        }

        window.location.assign(href)
    }
}

if (!customElements.get("ajax-pagination-element")) {
    customElements.define("ajax-pagination-element", AjaxPaginationElement)
}
